<template>
  <v-container fluid>
    <v-row class="ml-1">
      <global-stallholder-single-select
        @stallholder-changed="handleStallholderChange"
      />
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-home </v-icon>
            Users
            <v-spacer />
            <v-dialog v-model="dialog" max-width="500px" dark>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  dark
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!canAddUsers"
                >
                  <v-icon left x-small> mdi-plus </v-icon>
                  Add Users
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="text-h6">
                  {{ formTitle }}
                </v-card-title>
                <!-- <v-divider></v-divider> -->

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <label>
                        <B>Event Name:-</B>
                        {{ currentEvent.EventName || "N/A" }}
                      </label>
                      <br />
                      <label>
                        <B>Stallholder Name:-</B>
                        {{ currentStallholder.StallholderName || "N/A" }}
                      </label>

                      <v-text-field
                        v-model="editedItem.TerminalUserName"
                        label="Terminal UserName"
                        :rules="[(v) => !!v || 'Terminal UserName is required']"
                      ></v-text-field>

                      <v-text-field
                        v-model="editedItem.Pin"
                        type="number"
                        label="Pin"
                        :rules="[(v) => !!v || 'Pin is required']"
                      ></v-text-field>

                      <v-combobox
                        v-model="editedItem.SecLevel"
                        :items="secLevelOptions"
                        label="Security Level"
                        :rules="[(v) => !!v || 'Security Level is required']"
                        required
                      ></v-combobox>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="save"> Save </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px" dark>
              <v-card>
                <v-card-title class="text-h5">
                  Are you sure you want to Delete User?
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm">
                    OK
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="terminalUsers"
              single-select
              return-object
              class="elevation-5"
            >
              <template v-slot:item.TerminalUserName="{ item }">
                {{ item.TerminalUserName || "No data available" }}
              </template>
              <template v-slot:item.SecLevel="{ item }">
                {{ item.SecLevel || "No data available" }}
              </template>
              <template v-slot:top>
                <!-- Empty top slot to remove toolbar gap -->
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
              </template>
              <template v-slot:no-data>
                <div class="text-center pa-4">
                  <v-icon large color="grey lighten-1" class="mb-2">
                    mdi-account-off
                  </v-icon>
                  <div class="grey--text">
                    <span v-if="!hasStallholders">
                      No stallholders available for this event
                    </span>
                    <span v-else-if="!currentStallholder">
                      Please select a stallholder to view users
                    </span>
                    <span v-else>
                      No users found for
                      {{ currentStallholder.StallholderName }}
                    </span>
                  </div>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import "izitoast/dist/css/iziToast.min.css";
import iziToast from "izitoast/dist/js/iziToast.min.js";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  data: () => ({
    dialog: false,
    dialogDelete: false,
    valid: true,
    terminalUsers: [],

    headers: [
      { text: "Terminal User Name", value: "TerminalUserName" },
      { text: "Security Level", value: "SecLevel" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    editedIndex: -1,
    editedItem: {
      EventId: "",
      StallholderId: "",
      TerminalUserName: "",
      Pin: "",
      SecLevel: "",
    },
    defaultItem: {
      EventId: "",
      StallholderId: "",
      TerminalUserName: "",
      Pin: "",
      SecLevel: "",
    },

    secLevelOptions: ["Manager", "User"],
  }),

  computed: {
    ...mapState("admin", [
      "currentEvent",
      "currentStallHolders",
      "currentStallholder",
    ]),

    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    },

    selectedStallHolder: {
      get() {
        return this.currentStallholder;
      },
      set(value) {
        this.setCurrentStallholder(value);
      },
    },

    hasStallholders() {
      return this.currentStallHolders && this.currentStallHolders.length > 0;
    },

    canAddUsers() {
      return this.hasStallholders && this.currentStallholder;
    },
  },

  watch: {
    dialog(val) {
      if (!val) {
        this.close();
        this.setEventSelectorDisabled(false);
      } else {
        // Set default stallholder data when opening dialog
        this.editedItem.StallholderId =
          this.currentStallholder?.StallholderId || "";
        this.setEventSelectorDisabled(true);
      }
    },

    dialogDelete(val) {
      if (!val) {
        this.closeDelete();
        this.setEventSelectorDisabled(false);
      } else {
        this.setEventSelectorDisabled(true);
      }
    },

    currentStallholder: {
      handler(newStallholder) {
        if (newStallholder?.TerminalUsers) {
          this.terminalUsers = newStallholder.TerminalUsers;
        } else {
          this.terminalUsers = [];
        }
      },
      immediate: true,
    },

    // Auto-select first stallholder if none selected but stallholders are available
    currentStallHolders: {
      handler(newStallHolders) {
        if (
          newStallHolders &&
          newStallHolders.length > 0 &&
          !this.currentStallholder
        ) {
          // Auto-select the first stallholder if none is currently selected
          this.setCurrentStallholder(newStallHolders[0]);
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapMutations("admin", [
      "setCurrentStallholder",
      "setEventSelectorDisabled",
    ]),
    ...mapActions("admin", ["createEvent", "getEventMetadata"]),

    handleStallholderChange(stallholder) {
      if (stallholder) {
        this.setCurrentStallholder(stallholder);
        this.terminalUsers = stallholder.TerminalUsers || [];
      }
    },

    editItem(item) {
      this.editedIndex = this.terminalUsers.indexOf(item);

      // Find and set the stallholder for this user
      const stallholder = this.currentStallHolders.find(
        (sh) => sh.StallholderId === item.StallholderId
      );
      if (stallholder) {
        this.setCurrentStallholder(stallholder);
      }

      // Set edit form data
      this.editedItem = {
        TerminalUserId: item.TerminalUserId,
        StallholderId: item.StallholderId,
        TerminalUserName: item.TerminalUserName,
        Pin: item.Pin,
        SecLevel: item.SecLevel,
      };

      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.terminalUsers.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      try {
        if (this.editedItem.TerminalUserId) {
          const eventItem = [
            {
              Type: "TerminalUser",
              Action: "delete",
              Properties: this.editedItem,
            },
          ];

          await this.createEvent({ event_items: eventItem });

          // Refresh the admin state to get updated data from server
          if (this.currentEvent?.EventId) {
            await this.getEventMetadata(this.currentEvent.EventId);
          }

          // Remove from local array
          this.terminalUsers.splice(this.editedIndex, 1);

          iziToast.success({
            title: "User",
            message: "Successfully deleted record!",
            position: "topRight",
          });
        }
      } catch (error) {
        console.error("Delete error:", error);
        iziToast.warning({
          title: "User",
          message: "Failed to delete record!",
          position: "topRight",
        });
      }

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    async save() {
      if (!this.$refs.form.validate()) return;

      // Additional validation
      if (!this.currentEvent || !this.currentEvent.EventId) {
        iziToast.warning({
          title: "User",
          message: "Please select an event first!",
          position: "topRight",
        });
        return;
      }

      if (!this.currentStallholder || !this.currentStallholder.StallholderId) {
        iziToast.warning({
          title: "User",
          message: "Please select a stallholder first!",
          position: "topRight",
        });
        return;
      }

      try {
        this.editedItem.EventId = this.currentEvent.EventId;
        this.editedItem.StallholderId = this.currentStallholder.StallholderId;

        const eventItem = [
          {
            Type: "TerminalUser",
            Action: this.editedIndex === -1 ? "create" : "update",
            Properties: this.editedItem,
          },
        ];

        await this.createEvent({ event_items: eventItem });

        // Refresh the admin state to get updated data from server
        if (this.currentEvent?.EventId) {
          await this.getEventMetadata(this.currentEvent.EventId);
        }

        // Update local array
        if (this.editedIndex > -1) {
          Object.assign(this.terminalUsers[this.editedIndex], this.editedItem);
        } else {
          this.terminalUsers.push({ ...this.editedItem });
        }

        iziToast.success({
          title: "User",
          message: "Successfully saved record!",
          position: "topRight",
        });
      } catch (error) {
        console.error("Save error:", error);
        iziToast.warning({
          title: "User",
          message: "Failed to save record!",
          position: "topRight",
        });
      }

      this.close();
    },
  },
};
</script>

<style scoped>
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
</style>
